<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>订单列表</h3>
                </el-col>
            </el-row>
        </div>
        <el-row style="margin-bottom: 20px;">
            <el-button :type="i.checked ? 'info' : 'warning'" v-for="(i,index) in filterBtn" :key="i.name" @click="Search(index)">
                {{ i.name }}
            </el-button>

        </el-row>
        <el-form :inline="true" ref="formInline" :model="formInline" class="demo-form-inline">
            <el-form-item label="昵称" prop="nickName">
                <el-input v-model="formInline.nickName" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="username">
                <el-input v-model="formInline.username" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="订单编号" prop="orderNo">
                <el-input v-model="formInline.orderNo" placeholder="订单编号"></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="dayStart">
                <el-date-picker v-model="formInline.dayStart" type="date" placeholder="选择日期" @change="startChange" :picker-options="pickerOptionsStart">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="dayStart">
                <el-date-picker v-model="formInline.dayEnd" type="date" placeholder="选择日期" :picker-options="pickerOptionsEnd" @change="endChange">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="SearchFilter">搜索</el-button>
                <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="fetchList" v-loading="loading" element-loading-text="拼命加载中">
            <el-table-column prop="orderNo" label="订单编号">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="用户名">
                <span v-if="row.userManage">{{row.userManage.nickName}}</span>
            </el-table-column>
            <el-table-column prop="rentDay" label="租赁天数">
            </el-table-column>
            <el-table-column prop="dispalyExtra.paidData.rental" label="租金金额">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="支付方式">
                <span>{{ row.isAlipayMini ? '支付宝支付' : '微信支付'}}</span>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="订单状态">
                <div>
                    <span v-if="row.status === 0">待付款</span>
                    <span v-if="row.status === 1">待发货</span>
                    <span v-if="row.status === 2">交易关闭</span>
                    <span v-if="row.status === 3">待收货</span>
                    <span v-if="row.status === 4">待返还</span>
                    <span v-if="row.status === 5">待返还</span>
                    <span v-if="row.status === 6">待返还确认</span>
                    <span v-if="row.status === 7">已完成</span>
                    <span v-if="row.status === 8">退款中</span>
                    <span v-if="row.status === 9">已退款</span>
                    <span v-if="row.status === 98">已预约顺丰</span>
                    <span v-if="row.status === 99">完成中</span>
                    <span v-if="row.status === 100">已删除</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="下单时间">
                <span v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="操作">
                <span>
                                                                                        <el-button @click="handleView($index, row)" type="text" size="small">查看详情</el-button>
                                                                                    </span>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>

    </div>
</template>

<script>
    import {
        getOrder,
        getOrderCount,
        getUsersDetail,
        filterUser
    } from '../../api/version'

    export default {
        data() {
            return {
                filterBtn: [{
                    name: '全部订单',
                    checked: true
                }, {
                    name: '待付款',
                    checked: false
                }, {
                    name: '待发货',
                    checked: false
                }, {
                    name: '待收货',
                    checked: false
                }, {
                    name: '待返还确认',
                    checked: false
                }, {
                    name: '已完成',
                    checked: false
                }, {
                    name: '交易关闭',
                    checked: false
                }, {
                    name: '近三月',
                    checked: false
                }, {
                    name: '待返还',
                    checked: false
                }],
                fetchList: [],
                formInline: {
                    nickName: '',
                    username: '',
                    dayStart: '',
                    dayEnd: '',
                    orderNo: ''
                },
                pickerOptionsStart: {
                    disabledDate(time) {

                    }
                },
                pickerOptionsEnd: {
                    disabledDate(time) {

                    }
                },
                currentPage: 1,
                totalNum: 0,
                loading: true,
                filter: ''
            }
        },

        created() {
            this.filter = JSON.stringify({
                "limit": 20,
                "skip": 0,
                "order": "id desc",
                'include': 'userManage'
            })
            getOrder(sessionStorage.userId, this.filter).then(res => {
                let All = res.data
                this.totalCount = res.data.length
                All.forEach((item, index) => {
                    let day = 0
                    if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                        day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                        All[index].rentDay = day === 0 ? '1' : day + 1
                    }

                    this.fetchList = All
                })
                if (!All.length) {
                    this.fetchList = All
                }

                this.loading = false
            })
            getOrderCount(sessionStorage.userId, JSON.stringify({})).then(res => {
                console.log(res.data)
                this.totalNum = res.data.count
            })

        },

        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true
                this.filter = JSON.parse(this.filter)
                this.filter['skip'] = 20 * (--val)
                this.filter = JSON.stringify(this.filter)
                getOrder(sessionStorage.userId, this.filter).then(res => {
                    let All = res.data
                    this.totalCount = res.data.length
                    All.forEach((item, index) => {
                        let day = 0
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                            All[index].rentDay = day === 0 ? '1' : day + 1
                        }

                        this.fetchList = All
                    })
                    if (!All.length) {
                        this.fetchList = All
                    }

                    this.loading = false

                })
            },
            handleView(index, row) {
                this.$router.push('/orderDetail/' + row.id)
            },
            selectionChange: function(selections) {
                this.$emit("selectionChange", selections);
            },
            Search(id) {
                console.log(id)
                this.loading = true
                this.currentPage = 1
                this.resetForm('formInline')
                this.filterBtn.forEach(item => {
                    item.checked = false
                })
                this.filterBtn[id].checked = true
                if (id === 0) {
                    //获取全部订单
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage'
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({})).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })

                } else if (id === 1) {
                    //获取待付款订单
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            'status': 0
                        }
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        'status': 0

                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                } else if (id === 2) {
                    //获取待发货订单
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            'status': 1
                        }
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false

                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        'status': 1

                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                } else if (id === 3) {
                    console.log('aa')
                    //获取待收货订单
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            'status': 3
                        }
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        'status': 3

                    })).then(res => {
                        console.log(res.data, 'fffff')
                        this.totalNum = res.data.count
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })

                } else if (id === 4) {
                    //获取待返还确认订单
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            'status': 6
                        }
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            console.log(item, 'a')
                            this.loading = false
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                            }
                            All[index].rentDay = day === 0 ? '1' : day + 1

                        })
                        this.fetchList = All
                        this.loading = false
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        'status': 6

                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                } else if (id === 5) {
                    //获取已完成订单
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            'status': 7
                        }
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        'status': 7

                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                } else if (id === 6) {
                    //获取交易关闭订单
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            'status': 2
                        }
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        'status': 2

                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                } else if (id === 7) {
                    //获取近三月的订单
                    var date = new Date();
                    var t = date.getTime();
                    var m = t - 30 * 24 * 3600 * 1000;
                    var s = new Date(m);
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            created: {
                                gt: s
                            }
                        }
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        crreated: {
                            gt: s
                        }

                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })

                } else if (id === 8) {
                    //待返还
                    this.filter = JSON.stringify({
                        "limit": 20,
                        "skip": 0,
                        "order": "id desc",
                        'include': 'userManage',
                        'where': {
                            'status': 5
                        }
                    })
                    getOrder(sessionStorage.userId, this.filter).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })
                    getOrderCount(sessionStorage.userId, JSON.stringify({

                        'status': 5

                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                }

            },
            SearchFilter() {
                console.log(this.filter)
                this.fetchList = []
                this.totalNum = 0
                let status = ''
                let countFilter = {}
                let ifUser = false
                let filterUserData = {
                    'where': {
                    }
                }
                // this.filter = JSON.parse(this.filter)
                if (this.formInline.nickName) {

                    filterUserData.where.nickName = {
                        'like': '%25' + this.formInline.nickName + '%25'
                    }
                    ifUser = true
                }
                if (this.formInline.username) {
                    filterUserData.where.username = {
                        'like': '%25' + this.formInline.username + '%25'
                    }
                    ifUser = true
                }
                //查询用户
                if (ifUser) {
                    filterUser(sessionStorage.userId, JSON.stringify(filterUserData)).then(res => {
                        console.log(res.data)

                        if (res.data && res.data.length) {
                            res.data.forEach(item => {
                                countFilter.userId = item.userId
                                if (this.formInline.orderNo) {
                                    countFilter.orderNo = this.formInline.orderNo
                                }
                                if (this.formInline.dayEnd || this.formInline.dayStart) {
                                    countFilter.created = {}
                                }
                                if (this.formInline.dayEnd && this.formInline.dayStart) {
                                    countFilter.created.between = [this.formInline.dayStart, this.formInline.dayEnd]
                                } else if (this.formInline.dayStart) {
                                    countFilter.created.gt = this.formInline.dayStart
                                } else if (this.formInline.dayEnd) {
                                    countFilter.created.lt = this.formInline.dayEnd
                                }

                                let countFilter2 = {
                                    'where': JSON.parse(JSON.stringify(countFilter))
                                }
                                countFilter2.limit = 20
                                countFilter2.skip = 0
                                countFilter2.order = 'id desc'
                                countFilter2.include = 'userManage'
                                this.filter = JSON.stringify(countFilter2)

                                getOrder(sessionStorage.userId, JSON.stringify(countFilter2)).then(res => {
                                    let All = res.data
                                    this.totalCount = res.data.length
                                    All.forEach((item, index) => {
                                        let day = 0
                                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                            All[index].rentDay = day === 0 ? '1' : day + 1
                                        }


                                    })
                                    this.fetchList = this.fetchList.concat(All)
                                    // if (!All.length) {
                                    //     this.fetchList = this.fetchList.concat(All)
                                    // }

                                    this.loading = false
                                })


                                getOrderCount(sessionStorage.userId, JSON.stringify(countFilter)).then(res => {
                                    console.log(res.data)
                                    this.totalNum += res.data.count
                                    this.currentPage = 1
                                })
                            })

                        } else {
                            this.totalNum = 0
                            this.fetchList = []
                            return false
                        }

                    })
                } else {
                    if (this.formInline.orderNo) {
                        countFilter.orderNo = this.formInline.orderNo
                    }
                    if (this.formInline.dayEnd || this.formInline.dayStart) {
                        countFilter.created = {}
                    }
                    if (this.formInline.dayEnd && this.formInline.dayStart) {
                        countFilter.created.between = [this.formInline.dayStart, this.formInline.dayEnd]
                    } else if (this.formInline.dayStart) {
                        countFilter.created.gt = this.formInline.dayStart
                    } else if (this.formInline.dayEnd) {
                        countFilter.created.lt = this.formInline.dayEnd
                    }

                    let countFilter2 = {
                        'where': JSON.parse(JSON.stringify(countFilter))
                    }
                    countFilter2.limit = 20
                    countFilter2.skip = 0
                    countFilter2.order = 'id desc'
                    countFilter2.include = 'userManage'
                    this.filter = JSON.stringify(countFilter2)

                    getOrder(sessionStorage.userId, JSON.stringify(countFilter2)).then(res => {
                        let All = res.data
                        this.totalCount = res.data.length
                        All.forEach((item, index) => {
                            let day = 0
                            if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                                All[index].rentDay = day === 0 ? '1' : day + 1
                            }

                            this.fetchList = All
                        })
                        if (!All.length) {
                            this.fetchList = All
                        }

                        this.loading = false
                    })


                    getOrderCount(sessionStorage.userId, JSON.stringify(countFilter)).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                }













            },
            startChange(val) {
                console.log(val)
                this.pickerOptionsEnd = {
                    disabledDate(time) {
                        return time.getTime() < new Date(val).getTime();
                    }
                }
            },
            resetForm(formName) {
                this.formInline.dayEnd = ''
                this.formInline.dayStart = ''
                this.$refs[formName].resetFields();
            },
            endChange(val) {
                console.log(val)
                this.pickerOptionsStart = {
                    disabledDate(time) {
                        return time.getTime() > new Date(val).getTime();
                    }
                }
            }
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }

    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// OrderList.vue?8086964a